import {
  ApiResponseError,
  ApiSessionTimeoutError,
  classifyApiError,
  unwrapResponseModel
} from '../api/responseModel';
import { readLegacyCompatSession } from '../legacy/legacySession';

export {
  ApiResponseError as InscripcionesApiError,
  ApiSessionTimeoutError as InscripcionesSessionTimeoutError,
  classifyApiError as classifyInscripcionesError,
  unwrapResponseModel
};

export function readAlumnoCodigosSesion() {
  const session = readLegacyCompatSession();
  return session?.alumnoCodigos || '';
}

export function toCreateInscripcionCursadaPayload({
  cursadaCod,
  alumnoxCarreraCod,
  materiaCarreraCod,
  ignorarCorrelatividad
}) {
  return {
    CursadaCod: cursadaCod,
    AlumnoxCarreraCod: alumnoxCarreraCod,
    MateriaCarreraCod5: materiaCarreraCod,
    IgnorarCorrelatividad: ignorarCorrelatividad
  };
}

export function toUpdateInscripcionCursadaPayload({
  id,
  cursadaCod,
  alumnoxCarreraCod,
  materiaCarreraCod,
  estado,
  ignorarCorrelatividad = false,
}) {
  return {
    CursadaCod: cursadaCod,
    AlumnoxCarreraCod: alumnoxCarreraCod,
    MateriaCarreraCod5: materiaCarreraCod,
    InscripcionCursadaCod: id,
    InscripcionCursadaEstado: estado,
    IgnorarCorrelatividad: ignorarCorrelatividad,
  };
}

export function toInscripcionCursadaMultiplePayload({
  alumnoxCarreraCod,
  ignorarCorrelatividad,
  cursadas
}) {
  return {
    AlumnoxCarreraCod: alumnoxCarreraCod,
    IgnorarCorrelatividad: ignorarCorrelatividad,
    Cursadas: cursadas.map((item) => ({
      Cursada: item.cursada,
      MateriaCarreraCod3: item.materiaCarreraCod
    }))
  };
}

export function toInscripcionExamenMultiplePayload({
  alumnoxCarreraCod,
  mesas,
  ignorarCorrelatividad,
  ignorarRegularidad
}) {
  return {
    AlumnoxCarreraCod: alumnoxCarreraCod,
    Mesas: mesas.map((item) => ({
      Mesa: item.mesa,
      MateriaCarreraCod3: item.materiaCarreraCod,
      InscripcionExamenCondicionInsc: item.condicion
    })),
    IgnorarCorrelatividad: ignorarCorrelatividad,
    IgnorarRegularidad: ignorarRegularidad
  };
}

export function toUpdateInscripcionExamenPayload({
  id,
  alumnoxCarreraCod,
  mesaExamenCod,
  condicion,
  materiaCarreraCod,
  ignorarCorrelatividad = false,
  ignorarRegularidad = false,
}) {
  return {
    AlumnoxCarreraCod: alumnoxCarreraCod,
    MesaExamenCod: mesaExamenCod,
    InscripcionExamenCod: id,
    InscripcionExamenCondicionInsc: condicion,
    MateriaCarreraCod3: materiaCarreraCod,
    IgnorarCorrelatividad: ignorarCorrelatividad,
    IgnorarRegularidad: ignorarRegularidad,
  };
}

export function mapCarrerasInscripcionToSelectOptions(carreras) {
  return [...carreras]
    .sort((a, b) => a.carreraCod - b.carreraCod)
    .map((item) => ({
      value: `${item.carreraCod} - ${item.alumnoxCarreraCod}`,
      label: item.carreraNombre
    }));
}

export function validateInscripcionCursadaForm({ alumnoPresent, cursadaPresent }) {
  return Boolean(alumnoPresent && cursadaPresent);
}

export function validateInscripcionCursadaMultipleForm({ alumnoId, cursadaCount }) {
  return cursadaCount > 0 && alumnoId !== 0;
}

export function validateInscripcionExamenMultipleForm({ alumnoPresent, mesaCount, mesasWithCondicionCount }) {
  return Boolean(
    alumnoPresent
    && mesaCount > 0
    && mesaCount === mesasWithCondicionCount
  );
}

export function validateAlumnoSeleccionado(alumno) {
  return Boolean(alumno?.descripcion?.length > 1);
}

export function getInscripcionExamenEstadoLabel(estado) {
  if (estado === 'A') return 'Activa';
  if (estado === 'P') return 'Pendiente';
  if (estado === 'G') return 'Acta Generada';
  return 'Lista';
}

export function formatInscripcionExamenCondicion(condicion) {
  const value = (condicion || '').trim();
  if (value === 'Promocion') return 'Promoción';
  return value;
}

export function formatInscripcionExamenPeriodoGrid(row) {
  return [
    (row.periodoExamen || '').trim(),
    (row.llamado || '').trim(),
  ].filter(Boolean).join(' - ');
}

export function formatInscripcionCursadaAlumnoResultado(resultado) {
  const raw = String(resultado ?? '').trim();
  if (!raw || raw === 'Sin resultado') {
    return 'Sin resultado';
  }
  if (raw === 'R') return 'Regular';
  if (raw === 'L') return 'Libre';
  if (raw === 'P') return 'Promoción';
  if (raw === 'E') return 'Equivalencia';
  return raw;
}
